import React, { useState, useEffect } from 'react';
import useStores from '../../hooks/useStores';
import LocalizedLink from '../LocalizedLink';
import Image from '../Image';
import { Sizes } from '../../constants/Image';
import QuantityButton from '../Checkout/QuantityButton';
import Price from '../Price/Price';
import Translate from '../Translate/Translate';
import { observer } from 'mobx-react';
import './styles/MiniCart.scss';
import Modal from '../Modal';
import InBankModal from '../Product/InBankModal';
// import ClickAndTryModal from '../Product/ClickAndTryModal';
// import Uus from '../../images/uus.svg';
// import Stroke from '../../images/underline-stroke.svg';
import DiscountPercentage from '../Price/DiscountPercentage';
import {
  InformationCircleIcon,
  ShoppingBagIcon,
  XMarkIcon,
} from '@heroicons/react/24/outline';

const MiniCart = () => {
  const { cart, authentication } = useStores();
  const [cartItems, setCartItems] = useState([]);
  const [cartOpen, setCartOpen] = useState(false);

  useEffect(() => {
    setCartItems(cart.variations);
  }, [cart.variations]);

  const removeProduct = async (variation, quantity) => {
    await cart.removeItem(variation.code, quantity);
    setCartItems(cart.variations);
  };

  useEffect(() => {
    return () => {
      document.querySelector('body').classList.remove('scroll-lock');
    };
  }, []);

  const openCart = () => {
    setCartOpen(true);
    document.querySelector('body').classList.add('scroll-lock');
  };

  const closeCart = () => {
    setCartOpen(false);
    document.querySelector('body').classList.remove('scroll-lock');
  };

  const isAuthenticated = authentication?.loggedIn || false;

  return (
    <div className="relative">
      <button
        className={`flex justify-center items-center cursor-pointer relative rounded-sm h-12 w-12 lg:h-10 lg:max-w-10 lg:max-h-10 lg:min-h-10 lg:min-w-10 lg:border lg:border-solid ${
          cart.nrOfItems >= 1
            ? 'border-rgreen bg-rgreen text-white'
            : 'bg-white text-black'
        }`}
        onClick={cart.nrOfItems ? openCart : null}
        aria-label="Ostukorv"
        title="Ostukorv"
      >
        <ShoppingBagIcon className="w-8 h-8" />
        <div
          className={`font-axi-bold block text-xs -translate-x-2/4 -translate-y-2/4 absolute left-2/4 top-2/4 pt-2.5 ${
            cart.nrOfItems >= 1 ? 'text-white' : ' text-black'
          }`}
        >
          {cart.nrOfAllItems}
        </div>
      </button>
      <div
        className={`component-miniCart-container ${cartOpen ? 'open' : null}`}
      >
        <div className="component-miniCart-header">
          <h3 className="flex-1 text-4xl leading-12 font-axi-bold">
            <Translate component="mini-cart" keyword="cart" />
          </h3>
          <button className="component-miniCart-close" onClick={closeCart}>
            <Translate component="modal-content" keyword="close" />
          </button>
        </div>
        {cart.nrOfItems ? (
          <>
            <div className="flex flex-wrap -mx-2 my-0">
              {cartItems.length
                ? cartItems.map((variation, index) => {
                    const product = cart.getProduct(variation.product_id);

                    if (product) {
                      return (
                        <div key={index} className="flex pt-9 pb-0 px-2.5">
                          <div className="relative mr-4">
                            <LocalizedLink
                              to={`/toode/${product.slug}`}
                              onClick={closeCart}
                            >
                              <Image
                                className={
                                  'rounded-sm bg-rgrey-lightlight object-cover max-w-32 md:max-w-44 min-w-32 h-auto w-auto'
                                }
                                defaultSize={Sizes.W800}
                                image={product.cover}
                                allSizes={[Sizes.W300, Sizes.W540, Sizes.W800]}
                              />
                            </LocalizedLink>
                            <DiscountPercentage
                              prices={product.prices(isAuthenticated)}
                              productNew={product.isNew}
                              componentClassName="absolute left-0 text-xs!"
                              containerClassName="pt-2 pl-2 md:pt-4 md:pl-3"
                              hidePercentage={!isAuthenticated}
                            />
                          </div>
                          <div className="component-miniCart-product__content">
                            <div className="component-miniCart-product__titles">
                              <p className="text-xs leading-5 font-axi-bold text-rgrey lg:text-sm lg:leading-6">
                                {product.brandTitle} {product.gridTitle}
                              </p>
                              <h3 className="font-axi-bold text-2xl leading-6">
                                {product.title}
                              </h3>
                            </div>
                            <div className="component-miniCart-product__sizes">
                              <span className="component-miniCart-product__size">
                                {variation.value}
                              </span>
                              {product.product_code !== '4370' &&
                              product.product_code !== '4340' ? (
                                <QuantityButton data={variation} />
                              ) : null}
                            </div>
                            <Price
                              prices={product.prices(isAuthenticated)}
                              priceLabel={true}
                              productNew={product.isNew}
                              discountPriceClassname="text-base mr-1"
                              defaultPriceClassName="text-xs text-nowrap"
                              discountLabelClassname="text-xs"
                            />
                          </div>
                          {product.product_code !== '4370' &&
                          product.product_code !== '4340' ? (
                            <button
                              type="button"
                              aria-label="Eemalda toode"
                              className="absolute right-2 ml-auto flex h-6 w-6 items-center justify-center rounded-sm bg-black text-white cursor-pointer"
                              onClick={() =>
                                removeProduct(variation, variation.quantity)
                              }
                            >
                              <XMarkIcon
                                className="h-4 w-4 stroke-2"
                                aria-hidden="true"
                              />
                            </button>
                          ) : null}
                        </div>
                      );
                    }
                  })
                : null}
            </div>
            <div className="component-miniCart-footer">
              <div className="component-miniCart-footer__inner">
                {/* TELLI JA PROOVI: Hide this temporarily */}
                {/* <div className="flex items-center gap-2 my-5 pb-5 border-b">
                  <div className="text-rgreen">
                    <div className="inline-block relative">
                      <img
                        src={Uus}
                        alt="uus"
                        className="w-8 h-8 inline-block"
                      />
                      <img
                        src={Stroke}
                        alt="underline brush stroke"
                        className="absolute inset-x-0 w-full -mt-2"
                      />
                    </div>
                  </div>
                  <div className="font-axi-bold text-wrap">
                    <Translate component="checkout" keyword="modena-payment" />
                  </div>
                  <Modal
                    button={
                      <InformationCircleIcon
                        className="h-6 w-6 text-rgrey rounded-full border-0 cursor-pointer hover:bg-black hover:text-white transition-none"
                        title="Lisainfo"
                      />
                    }
                    content={<ClickAndTryModal />}
                    contentTitle={''}
                    modalClass="center overflow-auto min-h-auto"
                    ariaLabel="Lisainfo telli ja proovi kohta"
                  />
                </div> */}
                {cart.totalSum <= 2500 && (
                  <div className="my-5 pb-5 border-b">
                    <div className="flex items-center gap-2 mb-2">
                      <div className="font-axi-bold">
                        Maksa 3 või 6 võrdses osas
                      </div>
                      <Modal
                        button={
                          <InformationCircleIcon
                            className="h-6 w-6 text-rgrey rounded-full border-0 cursor-pointer hover:bg-black hover:text-white transition-none"
                            title="Lisainfo"
                          />
                        }
                        content={<InBankModal price={cart.totalSum} />}
                        contentTitle={
                          <img
                            src="https://rademar-1b47c.kxcdn.com/icons/inbank.svg"
                            alt="inbank"
                            className="h-10 w-auto m-5"
                          />
                        }
                        modalClass="center overflow-auto min-h-96 md:min-h-fit"
                        ariaLabel="Lisainfo Inbank makseviiside kohta"
                      />
                    </div>
                    <div className="flex gap-4 mr-2">
                      <div className="text-rpink text-nowrap whitespace-nowrap">
                        3<span className="text-xs"> &#10005; </span>
                        {(cart.totalSum / 3).toFixed(2)} €
                      </div>
                      <div className="text-rpink text-nowrap whitespace-nowrap">
                        6<span className="text-xs"> &#10005; </span>
                        {(cart.totalSum / 6).toFixed(2)} €
                      </div>
                    </div>
                    {cart.totalSum < 50 && (
                      <div className="text-xs tracking-tight mt-2">
                        Maksete jaotamiseks peab ostukorv olema vahemikus
                        50-2500 eur.
                      </div>
                    )}
                    <div className="mt-2">
                      <LocalizedLink
                        to={'/inbank'}
                        className="text-xs underline"
                      >
                        Tutvu tingimustega
                      </LocalizedLink>
                    </div>
                  </div>
                )}

                <p>
                  <Translate component="checkout" keyword="right-sum" />
                  <span>{cart.originalTotal} €</span>
                </p>
                {cart.totalDiscount == 0 ? null : (
                  <p>
                    <Translate component="checkout" keyword="discount-sum" />
                    <span> -{cart.totalDiscount} €</span>
                  </p>
                )}
                <p>
                  <Translate component="checkout" keyword="right-delivery" />
                  <span>{cart.shippingTotal} €</span>
                </p>
                <p>
                  <Translate component="checkout" keyword="right-total" />
                  <span>{cart.totalSum} €</span>
                </p>
              </div>
              <LocalizedLink
                className="component-miniCart-pay"
                to="/checkout"
                onClick={closeCart}
              >
                <Translate component="checkout" keyword="button" />
              </LocalizedLink>
            </div>
          </>
        ) : (
          <div className="component-miniCart-empty">
            <h4 className="text-base leading-7 font-axi-bold">
              <Translate component="mini-cart" keyword="empty" />
            </h4>
          </div>
        )}
      </div>
      <div
        className={`component-miniCart-overlay ${cartOpen ? 'open' : null}`}
        onClick={closeCart}
      />
    </div>
  );
};

export default observer(MiniCart);
